import React from "react";
import { Mail, Phone, Trash2 } from "lucide-react";
import { FORMATION_LABELS, SITUATION_LABELS, formatDate } from "./constants";

function InfoTile({ label, value }) {
  return (
    <div className="px-4 py-3 rounded-xl bg-[#fbfaf7] border border-[#e6ded0]">
      <div className="text-[10px] uppercase tracking-wider text-[#2c7a80] font-semibold mb-1">
        {label}
      </div>
      <div className="text-sm text-[#0e3a3f]">{value || "—"}</div>
    </div>
  );
}

export default function ContactDetail({ contact, onDelete }) {
  return (
    <div
      className="bg-white rounded-2xl border border-[#e6ded0] p-6 sticky top-24"
      data-testid="admin-contact-detail"
    >
      <div className="flex items-start justify-between gap-4 mb-5">
        <div>
          <div className="text-xs uppercase tracking-wider text-[#e8a04d] font-semibold mb-1">
            Reçue le {formatDate(contact.created_at)}
          </div>
          <h2 className="text-2xl font-serif text-[#0e3a3f]">
            {contact.firstName} {contact.lastName}
          </h2>
        </div>
        <button
          onClick={() => onDelete(contact.id)}
          className="p-2 rounded-lg text-red-600 hover:bg-red-50 transition-colors"
          title="Supprimer"
          data-testid="admin-delete-btn"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-5">
        <a
          href={`mailto:${contact.email}?subject=Votre demande CFMPE`}
          className="flex items-center gap-3 px-4 py-3 rounded-xl bg-[#fbfaf7] border border-[#e6ded0] hover:border-[#2c7a80] transition-colors"
          data-testid="admin-email-link"
        >
          <Mail className="w-4 h-4 text-[#2c7a80] flex-shrink-0" />
          <span className="text-sm text-[#0e3a3f] truncate">{contact.email}</span>
        </a>
        <a
          href={`tel:${contact.phone}`}
          className="flex items-center gap-3 px-4 py-3 rounded-xl bg-[#fbfaf7] border border-[#e6ded0] hover:border-[#2c7a80] transition-colors"
          data-testid="admin-phone-link"
        >
          <Phone className="w-4 h-4 text-[#2c7a80] flex-shrink-0" />
          <span className="text-sm text-[#0e3a3f]">{contact.phone}</span>
        </a>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-5">
        <InfoTile
          label="Formation"
          value={FORMATION_LABELS[contact.formation] || contact.formation}
        />
        <InfoTile
          label="Situation"
          value={SITUATION_LABELS[contact.situation] || contact.situation}
        />
      </div>

      <div>
        <div className="text-[10px] uppercase tracking-wider text-[#2c7a80] font-semibold mb-2">
          Message
        </div>
        <div className="p-4 rounded-xl bg-[#fbfaf7] border border-[#e6ded0] text-sm text-[#0e3a3f] leading-relaxed whitespace-pre-wrap">
          {contact.message}
        </div>
      </div>

      <a
        href={`mailto:${contact.email}?subject=Re%3A%20Votre%20demande%20CFMPE&body=Bonjour%20${encodeURIComponent(
          contact.firstName
        )}%2C%0A%0A`}
        className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-[#0e3a3f] hover:bg-[#1a5459] text-white font-semibold text-sm transition-colors"
        data-testid="admin-reply-btn"
      >
        <Mail className="w-4 h-4" /> Répondre par email
      </a>
    </div>
  );
}
